module.exports = __webpack_public_path__ + "img/love.093f79a4.svg";